"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdWordtimingeditor = _interopRequireDefault(require("cccisd-wordtimingeditor"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _wt = _interopRequireDefault(require("./wt.svg"));
var _bubbleLines = _interopRequireDefault(require("cccisd-icons/bubble-lines3"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _utils = require("./utils.js");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _reactRedux = require("react-redux");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var WordTimings = /*#__PURE__*/function (_React$Component) {
  _inherits(WordTimings, _React$Component);
  function WordTimings(props) {
    var _this;
    _classCallCheck(this, WordTimings);
    _this = _callSuper(this, WordTimings, [props]);
    _defineProperty(_assertThisInitialized(_this), "generateTimings", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var language, response, wordTimings, duration, words, contentTranscript, speechTranscript;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            language = _this.state.language;
            _this.setState({
              loading: true
            });
            _context.next = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              transcript: _this.props.content,
              lang: language
            });
          case 4:
            response = _context.sent;
            if (!(response.data.status === 'error')) {
              _context.next = 9;
              break;
            }
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: response.data.errorMessage
            });
            _this.setState({
              loading: false
            });
            return _context.abrupt("return");
          case 9:
            wordTimings = (0, _utils.adjustTimings)(_this.props.content, response.data.timingsArray);
            duration = response.data.duration; // Save updated timings again
            _context.next = 13;
            return _cccisdAxios["default"].put(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              result: {
                duration: duration,
                wordTimings: wordTimings,
                language: language
              }
            });
          case 13:
            words = (0, _utils.getWords)(_this.props.content);
            contentTranscript = words.join(' ');
            speechTranscript = response.data.speechTranscript || contentTranscript;
            _this.setState({
              loading: false,
              askToReplaceWithSpeechTranscript: !(0, _utils.isTranscriptTheSame)(contentTranscript, speechTranscript),
              speechTranscript: response.data.speechTranscript ? '<p>' + response.data.speechTranscript + '</p>' : undefined,
              speechTimingsArray: response.data.timingsArray,
              content: _this.props.content,
              wordTimings: wordTimings,
              duration: duration
            });
            if (!words.length) {
              _this.onReplaceWithSpeechTranscript(true);
            }
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "removeTimings", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response, audio;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this.setState({
              loading: true
            });
            _context2.next = 3;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('audio.production.asset.destroyAssetTimings', {
              fileId: _this.props.meta.audio.id
            }));
          case 3:
            response = _context2.sent;
            if (!(response.data.status === 'success')) {
              _context2.next = 11;
              break;
            }
            audio = _objectSpread({}, _this.props.meta.audio);
            delete audio.duration;
            delete audio.wordTimings;
            delete audio.language;
            _this.props.setContent(_this.props.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: audio
            }));
            return _context2.abrupt("return");
          case 11:
            (0, _cccisdNotification["default"])({
              message: 'Failed to remove word timings',
              type: 'danger'
            });
            _this.setState({
              loading: false
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "removeTimings", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var response, audio;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this.setState({
              loading: true
            });
            _context3.next = 3;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('audio.production.asset.destroyAssetTimings', {
              fileId: _this.props.meta.audio.id
            }));
          case 3:
            response = _context3.sent;
            if (!(response.data.status === 'success')) {
              _context3.next = 11;
              break;
            }
            audio = _objectSpread({}, _this.props.meta.audio);
            delete audio.duration;
            delete audio.wordTimings;
            delete audio.language;
            _this.props.setContent(_this.props.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: audio
            }));
            return _context3.abrupt("return");
          case 11:
            (0, _cccisdNotification["default"])({
              message: 'Failed to remove word timings',
              type: 'danger'
            });
            _this.setState({
              loading: false
            });
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "_onEditorChange", function (wordTimings) {
      _this.setState({
        wordTimings: wordTimings.map(function (item) {
          return (0, _pick2["default"])(item, ['start', 'end', 'word']);
        })
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onSubmit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            result = (0, _pick2["default"])(_this.state, ['duration', 'wordTimings', 'language', 'content']);
            _context4.next = 3;
            return _cccisdAxios["default"].put(Boilerplate.route('audio.production.asset', {
              fileId: _this.props.meta.audio.id
            }), {
              result: result
            });
          case 3:
            _this.props.setContent(_this.state.content, _objectSpread(_objectSpread({}, _this.props.meta), {}, {
              audio: _objectSpread(_objectSpread(_objectSpread({}, _this.props.meta.audio), result), {}, {
                transcript: _this.state.content
              })
            }));
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "onReplaceWithSpeechTranscript", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(replace) {
        var content, wordTimings;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              content = replace ? _this.state.speechTranscript : _this.props.content;
              wordTimings = (0, _utils.adjustTimings)(content, _this.state.speechTimingsArray);
              _this.setState({
                askToReplaceWithSpeechTranscript: false,
                wordTimings: wordTimings,
                content: content
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "isTooltip", function () {
      return (0, _get2["default"])(_this.props, 'meta.information') || (0, _get2["default"])(_this.props, 'meta.tooltips');
    });
    _defineProperty(_assertThisInitialized(_this), "showWordTimingsEditor", function () {
      return _this.state.wordTimings.length > 0 && !_this.state.loading;
    });
    _defineProperty(_assertThisInitialized(_this), "showMissingWordTimingsMessage", function () {
      return !_this.state.wordTimings.length && !_this.state.loading;
    });
    _defineProperty(_assertThisInitialized(_this), "replaceWithSpeechTranscript", function () {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, "The transcription of the audio is different from the existing text. Do you want to use it instead?"), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Existing text:")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: '2em'
        },
        dangerouslySetInnerHTML: {
          __html: _this.props.content
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Audio transcription:")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingLeft: '2em'
        },
        dangerouslySetInnerHTML: {
          __html: _this.state.speechTranscript
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        style: {
          marginRight: '1em'
        },
        onClick: function onClick() {
          return _this.onReplaceWithSpeechTranscript(true);
        }
      }, "Use audio transcription"), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this.onReplaceWithSpeechTranscript(false);
        }
      }, "Keep existing text")));
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      if (_this.isTooltip()) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          style: {
            margin: 0
          }
        }, "You cannot use word timings along with tooltips");
      }
      if (_this.state.askToReplaceWithSpeechTranscript) {
        return _this.replaceWithSpeechTranscript();
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, _this.state.loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true,
        type: "inline"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em',
          marginBottom: '1em'
        },
        className: "text-center"
      }, "Please be patient, it may take a few minutes")), _this.showMissingWordTimingsMessage() && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em',
          marginBottom: '1em'
        },
        className: "text-center"
      }, "Transcription for the audio file can not be generated."), _this.showWordTimingsEditor() && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", null, "Edit Word Timings"), /*#__PURE__*/_react["default"].createElement(_cccisdWordtimingeditor["default"], {
        onTimingChange: _this._onEditorChange,
        onSubmit: _this._onSubmit,
        timings: _this.state.wordTimings,
        audioFile: _this.props.meta.audio.url,
        width: 550,
        showSave: false,
        duration: _this.state.duration,
        generateTimings: _this.generateTimings,
        removeTimings: _this.removeTimings
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: _this._onSubmit
      }, "Submit"))));
    });
    _this.state = {
      loading: false,
      askToReplaceWithSpeechTranscript: false,
      speechTranscript: undefined,
      speechTimingsArray: [],
      wordTimings: (0, _get2["default"])(_this.props, 'meta.audio.wordTimings', []),
      content: _this.props.content,
      duration: (0, _get2["default"])(_this.props, 'meta.audio.duration', 0),
      language: (0, _utils.mapLanguage)(props.language)
    };
    _this.generateTimings = _this.generateTimings.bind(_assertThisInitialized(_this));
    _this.removeTimings = _this.removeTimings.bind(_assertThisInitialized(_this));
    _this.onReplaceWithSpeechTranscript = _this.onReplaceWithSpeechTranscript.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(WordTimings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isTooltip()) {
        return;
      }
      if (this.showWordTimingsEditor()) {
        return;
      }
      this.generateTimings();
    }
  }]);
  return WordTimings;
}(_react["default"].Component);
_defineProperty(WordTimings, "propTypes", {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  language: _propTypes["default"].string
});
var addIcon = function addIcon(content) {
  var wordTimings = (0, _get2["default"])(content, 'meta.audio.wordTimings', []);
  if (wordTimings.length === 0) {
    return false;
  }
  return /*#__PURE__*/_react["default"].createElement("i", {
    title: "with timings"
  }, /*#__PURE__*/_react["default"].createElement(_bubbleLines["default"], null));
};
var WordTimingsLanguageWrapper = function WordTimingsLanguageWrapper(props) {
  var language = (0, _reactRedux.useSelector)(function (state) {
    return state.flow.builder.language;
  });
  return /*#__PURE__*/_react["default"].createElement(WordTimings, _extends({}, props, {
    language: language
  }));
};
var _default = exports["default"] = {
  name: 'cccisdWordTimings',
  tooltip: 'Word Timings',
  image: _wt["default"],
  title: 'Word Timings',
  component: WordTimingsLanguageWrapper,
  addIcon: addIcon,
  disableCondition: function disableCondition(content, meta, currentElement) {
    return meta && meta.audio && meta.audio.resourceId ? false : true;
  }
};